<template>
  <div class="g-wrapper">
    <div class="g-forumMain">
      <ul class="m-liveList">
        <li v-for="(item, index) in newsList" :key="index">
          <img :src="item.thumbnail_url" alt="" class="u-liveThub" />
          <div class="u-liveMsg">
            <a :href="item.article_url" class="u-liveTitle">{{ item.title }}</a>
            <div class="u-liveStatus">
              <p class="u-publish">{{ item.published_at_str }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [],
    };
  },
  methods: {
    getNews(id) {
      let that = this;
      $.ajax({
        url:
          "http://www.nbd.com.cn/columns/" +
          id +
          "/articles_list.json?simple_info=1",
        methods: "get",
        success: function (data) {
          console.log("--news--");
          console.log(data);
          that.newsList = data;
        },
      });
    },
  },
  mounted() {
    let id = (this.forum = this.$route.params.id);
    this.getNews(id);
  },
};
</script>

<style lang='scss' scoped>
.m-liveList {
  width: 100%;
  li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    .u-liveThub {
      width: 280px;
      height: 160px;
    }
    .u-liveMsg {
      width: 355px;
      flex-direction: column;
      display: flex;
      justify-content: space-between;
    }
    .u-liveTitle {
      color: #535353;
      font-size: 28px;
      text-align: justify;
      text-decoration: none;
    }
    .u-liveStatus {
      display: inline-flex;
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: nowrap;
    }
    .u-liveTag {
      padding: 5px 10px;
      background: #e9e9eb;
      color: #1a75df;
      font-size: 20px;
      text-align: center;
      &.u-onLive {
        color: #f41538;
      }
    }
    .u-publish {
      font-size: 20px;
      color: #9e9e9e;
    }
  }
}
.g-forumMain {
      width: 730px;
  padding: 32px;
  box-sizing: border-box;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
}
</style>